import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { UserInfoService } from './user-info-service';
import { IAccessLogs } from '../interfaces/IAccessLogs';
import { IAccessLogsBySite } from '../interfaces/IAccessLogsBySite';
import { IAccessLogsByCategory } from '../interfaces/IAccessLogsByCategory';
import { IAccessLogsByChannel } from '../interfaces/IAccessLogsByChannel';
import { IAccessLogsByBuilding } from '../interfaces/IAccessLogsByBuilding';


@Injectable({
  providedIn: 'root'
})

export class LogssService extends RestCallService {
    public DataToSent:IAccessLogs = {
        pk_access_log: 0,
        fk_employee: 0,
        creation_date:new Date(),
        username:''
    }

    public DataSiteToSent:IAccessLogsBySite = {
        pk_access_log: 0,
        fk_site: 0,
        creation_date:new Date(),
        username:''
    }

    public DataBuildingToSent:IAccessLogsByBuilding = {
        pk_access_log: 0,
        fk_building: 0,
        creation_date:new Date(),
        username:''
    }

    public DataCategoryToSent:IAccessLogsByCategory = {
        pk_access_log: 0,
        fk_category: 0,
        creation_date:new Date(),
        username:''
    }

    public DataChannelToSent:IAccessLogsByChannel = {
        pk_access_log: 0,
        channel: '',
        creation_date:new Date(),
        username:''
    }

    constructor (public httpClient: HttpClient, public toastr: ToastrService, public notificationService: NotificationService, public translate: TranslateApplicationService,private userInfoService: UserInfoService) {
        super(httpClient, 'LockerLinkApi', toastr, notificationService, translate)
    }

    public AddAccessLog() {
        this.DataToSent.username = this.userInfoService.windowsNT;
        return this.post<IAccessLogs[]>('/api/Logs/AddAccessLog', this.DataToSent)
    }

    public AddSiteLog(idSite:any) {
        this.DataSiteToSent.fk_site = parseInt(idSite);
        return this.post<IAccessLogsBySite[]>('/api/Logs/AddSiteLog', this.DataSiteToSent)
    }

    public AddBuildingLog(idBuilding:any) {
        this.DataBuildingToSent.fk_building = parseInt(idBuilding);
        return this.post<IAccessLogsByBuilding[]>('/api/Logs/AddBuildingLog', this.DataBuildingToSent)
    }

    public AddCategoryLog(data: any) {
        this.DataCategoryToSent.fk_category = data;
        return this.post<IAccessLogsByCategory[]>('/api/Logs/AddCategoryLog', this.DataCategoryToSent)
    }

    public AddChannelLog(data: any) {
        this.DataChannelToSent.channel = data;
        return this.post<IAccessLogsByChannel[]>('/api/Logs/AddChannelLog', this.DataChannelToSent)
    }

}